import {useContext} from "react";
import {AccountContext} from "@/context/AccountProvider";

export const useAuth = () => {
	return useContext(AccountContext);
}
